var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalizedOfferTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9186 12.1786L11.5977 22.116C11.6077 22.3862 11.728 22.6465 11.9186 22.8332L29.2976 39.8589C29.7288 40.2813 30.4308 40.2813 30.862 39.8589L41.3316 29.6022C41.7628 29.1798 41.7628 28.497 41.3316 28.0696L23.9525 11.0439C23.757 10.8523 23.4962 10.7393 23.2205 10.7295L13.0768 11.0439C12.43 11.0144 11.9035 11.54 11.9286 12.1737L11.9186 12.1786ZM19.3245 17.7441C18.6175 18.8346 17.028 18.8346 16.321 17.7441C15.965 17.194 15.965 16.4719 16.321 15.9217C17.028 14.8312 18.6175 14.8312 19.3245 15.9217C19.6805 16.4719 19.6805 17.194 19.3245 17.7441Z",
    fill: "url(#paint0_linear_6598_9743)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3269 17.1659C13.0127 16.7012 3.61576 12.5009 6.96425 8.76613C8.2439 7.33885 13.9958 8.55703 16.7806 11.3448",
    stroke: "#1C3156",
    strokeWidth: 1.31588,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3061 24.671V29.2392C30.3061 29.6107 30.0061 29.917 29.6343 29.917H25.0623C23.6861 29.917 22.5708 28.7961 22.5708 27.4276C22.5708 26.059 23.6861 24.9381 25.0623 24.9381H25.3233V24.671C25.3231 23.296 26.4449 22.1816 27.8146 22.1816C29.1843 22.1816 30.3061 23.296 30.3061 24.671Z",
    fill: "#E52326"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6598_9743",
    x1: 43.0372,
    y1: 30.2395,
    x2: 22.6517,
    y2: 3.28125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalizedOfferTag);
export default __webpack_public_path__ + "static/media/PersonalizedOfferTag.9bb0a9119ac3ec12b4cea48c6540c2b2.svg";
export { ForwardRef as ReactComponent };